'use client';

import { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';

// Anime l'entrée d'une section au scroll (fondu + léger glissement vers le
// haut), une seule fois. Respecte prefers-reduced-motion (contenu visible
// immédiatement, sans animation).
export function Reveal({
  children,
  className,
  delayMs = 0,
  ...rest
}: {
  children: React.ReactNode;
  className?: string;
  delayMs?: number;
} & React.HTMLAttributes<HTMLDivElement>) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setVisible(true);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { rootMargin: '-80px', threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      {...rest}
      className={cn(
        "transition-all duration-700 ease-out",
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8",
        className
      )}
      style={{ transitionDelay: visible ? `${delayMs}ms` : '0ms' }}
    >
      {children}
    </div>
  );
}
